import {
  FETCH_FIXTURES_PENDING,
  FETCH_FIXTURES_REJECTED,
  FETCH_FIXTURES_FULFILLED,
} from "../../constants/fixture";

const fixture = (state = {}, action) => {
  switch (action.type) {
    case FETCH_FIXTURES_PENDING:
      return { ...state, loading: true, error: false, success: false };
    case FETCH_FIXTURES_REJECTED:
      return { ...state, loading: false, error: true, success: false };
    case FETCH_FIXTURES_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        list: action.payload.data,
      };
    default:
      return state;
  }
};
export default fixture;
